import {
    size, clone, cloneDeep,
    assign as _assign
} from 'lodash';
import {Utils} from './Utils';

export class ObjectUtils {
    public static keyCount(obj: any): number {
        return size(obj);
    }

    /**
     * Determine if @obj is null/undefined/json prop count === 0
     * @param obj - object to test
     * @returns {boolean} - returns true when @obj is null or undefined or json prop count === 0; otherwise returns false
     */
    public static isNullOrEmpty(obj: any): boolean {
        return Utils.isNullOrUndefined(obj) || ObjectUtils.keyCount(obj) === 0;
    }

    /**
     * Clones source object.
     * @param obj - source object to be cloned
     * @param deep - true to deep clone or false to do normal clone.
     */
    public static clone<T>(obj: T, deep: boolean = true): T {
        return deep ? cloneDeep(obj) : clone(obj);
    }

    /**
     * Assigns sources into @object
     * @param object - target object where to assign(merge) sources
     * @param source - source to merge
     */
    public static assign<TObject extends {}, TSource extends {}, TResult extends {}>(object: TObject,
        source: TSource): TResult {
        return _assign<TObject, TSource, TResult>(object, source);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/ObjectUtils.ts
 **/